import {
    UPDATEWALLETOWNERSETTING_SUCCESS,
    UPDATEWALLETOWNERSETTING_FAILED,
    RESET_UPDATEWALLETOWNERSETTING,
    LOADING_UPDATEWALLETOWNERSETTING,
    NETWORK_ERROR_UPDATEWALLETOWNERSETTING,
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: "",
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_UPDATEWALLETOWNERSETTING:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: "",
            };
        case UPDATEWALLETOWNERSETTING_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case UPDATEWALLETOWNERSETTING_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case NETWORK_ERROR_UPDATEWALLETOWNERSETTING:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: "",
            };
        case RESET_UPDATEWALLETOWNERSETTING:
            return (state = initialState);
        default:
            return state;
    }
};
